// extracted by mini-css-extract-plugin
export default {"recos":"v3-z","productCardOverride":"w3-z","rowHasBadge":"x3-z"};